export const HOTSTORAGE_REQUEST_HEADERS = { 'X-Use-Hotstorage': '1' } as const;

export const FQS_HOTSTORAGE_REQUEST_OPTIONS = {
  requestHeaders: { ...HOTSTORAGE_REQUEST_HEADERS },
};
